import Phaser from 'phaser'
import LifeLabel from '../ui/LifeLabel.js'
import ScoreLabel from '../ui/ScoreLabel.js'
export default class MemoryGameScene extends Phaser.Scene
{
    constructor()
    {
        super('super-runnns-scene')
    }

    init()
    {
        this.gameHalfWidth = this.scale.width * 0.5
        this.gameHalfHeight = this.scale.height * 0.5
        this.platforms = undefined
        this.player = undefined
        this.cursors = this.input.keyboard.createCursorKeys()
        this.apel = undefined
        this.saw = undefined
        this.bendera = undefined
        this.api = undefined
        this.Strawberry = undefined
        this.Kiwi = undefined
        this.Bananas = undefined
        this.api2 = undefined
        this.api3 = undefined
        this.saw2 = undefined
        this.saw3 = undefined
        this.saw4 = undefined
        this.LifeLabel = undefined
        this.ScoreLabel = undefined

   
    }

    preload()
    {
        this.load.image('bg', 'images/bg.png')
        this.load.image('Brown', 'images/Brown.png')
        this.load.image('End', 'images/End.png')
        this.load.image('Grey', 'images/Grey.png')
        this.load.image('Jalanan', 'images/Jalanan.png')
        this.load.image('jumpss', 'images/jumpss.png')
        this.load.image('Start', 'images/Start.png')
        this.load.audio('backsound', 'sfx/backsound.mp3')
        this.load.audio('eat', 'sfx/eat.mp3')
        

        this.load.spritesheet('Bananas', 'images/Bananas.png',
        {frameWidth: 32, frameHeight: 32})
        this.load.spritesheet('saw', 'images/saw.png',
        {frameWidth: 38, frameHeight: 38})
        this.load.spritesheet('saw2', 'images/saw2.png',
        {frameWidth: 38, frameHeight: 38})
        this.load.spritesheet('saw3', 'images/saw3.png',
        {frameWidth: 38, frameHeight: 38})
        this.load.spritesheet('saw4', 'images/saw4.png',
        {frameWidth: 38, frameHeight: 38})
        this.load.spritesheet('Strawberry', 'images/Strawberry.png',
        {frameWidth: 32, frameHeight: 32})
        this.load.spritesheet('Kiwi', 'images/Kiwi.png',
        {frameWidth: 32, frameHeight: 32})
        this.load.spritesheet('Memukul', 'images/Memukul.png',
        {frameWidth: 32, frameHeight: 32})
        this.load.spritesheet('On', 'images/On.png',
        {frameWidth: 16, frameHeight: 32})
        this.load.spritesheet('saw', 'images/saw.png',
        {frameWidth: 38, frameHeight: 38})
        this.load.spritesheet('Lompat.Jauh', 'images/Lompat.Jauh.png',
        {frameWidth: 32, frameHeight: 32})
        this.load.spritesheet('Lari', 'images/Lari.png',
        {frameWidth: 32, frameHeight: 32})
        this.load.spritesheet('Apple', 'images/Apple.png',
        {frameWidth: 32, frameHeight: 32})
        this.load.spritesheet('Strawberry', 'images/Strawberry.png',
        {frameWidth: 32, frameHeight: 32})
        this.load.spritesheet('Checkpoint', 'images/Checkpoint.png',
        {frameWidth: 64, frameHeight: 64})
        this.load.spritesheet('Diem', 'images/Diem.png',
        {frameWidth: 32, frameHeight: 32})
        this.load.spritesheet('player','images/player.png',
        {frameWidth: 58, frameHeight: 58.3333333})
        this.load.spritesheet('player2','images/player2.png',
        {frameWidth: 50.09090, frameHeight: 58.3333333})
        this.load.spritesheet('player3','images/player3.png',
        {frameWidth: 50.727272, frameHeight: 56.75})
        this.load.spritesheet('api2', 'images/api2.png',
        {frameWidth: 16, frameHeight: 32})
        this.load.spritesheet('api3', 'images/api3.png',
        {frameWidth: 16, frameHeight: 32})


        
    }

    create()
    {
        this.add.image(350,350,'bg').setScale(11)

        this.platforms = this.physics.add.staticGroup()
        this.platforms.create(25,675,'Jalanan').setScale(2.5).refreshBody()
        this.platforms.create(142,675,'Jalanan').setScale(2.5).refreshBody()
        this.platforms.create(259,675,'Jalanan').setScale(2.5).refreshBody()
        this.platforms.create(376,675,'Jalanan').setScale(2.5).refreshBody()
        this.platforms.create(376,675,'Jalanan').setScale(2.5).refreshBody()
        this.platforms.create(493,675,'Jalanan').setScale(2.5).refreshBody()
        this.platforms.create(610,675,'Jalanan').setScale(2.5).refreshBody()
        this.platforms.create(727,675,'Jalanan').setScale(2.5).refreshBody()
        this.platforms.create(39,570,'Start').setScale(1.5).refreshBody()
        this.platforms.create(130,555,'Grey')
        this.platforms.create(160,555,'Grey')
        this.platforms.create(190,555,'Grey')
        this.platforms.create(280,455,'Grey')
        this.platforms.create(310,455,'Grey')
        this.platforms.create(340,455,'Grey')
        this.platforms.create(450,355,'Grey')
        this.platforms.create(480,355,'Grey')
        this.platforms.create(510,355,'Grey')
        this.platforms.create(410,150,'Grey')
        this.platforms.create(440,150,'Grey')
        this.platforms.create(470,150,'Grey')
        this.platforms.create(110,90,'Grey')
        this.platforms.create(140,90,'Grey')
        this.platforms.create(170,90,'Grey')
        this.platforms.create(510,520,'Grey')
        this.platforms.create(540,520,'Grey')
        this.platforms.create(570,520,'Grey')
        this.platforms.create(540,70,'Grey')
        this.platforms.create(570,70,'Grey')
        this.platforms.create(600,70,'Grey')
        this.platforms.create(190,190,'Grey')
        this.platforms.create(220,190,'Grey')
        this.platforms.create(250,190,'Grey')
        this.platforms.create(170,350,'Grey')
        this.platforms.create(200,350,'Grey')
        this.platforms.create(230,350,'Grey')
       

        this.player=this.createPlayer()

        this.physics.add.collider(this.player, this.platforms)
        this.input.keyboard.createCursorKeys()
        this.apel = this.physics.add.sprite(320,430, 'Apple').setScale(1.5)
        this.Bananas = this.physics.add.sprite(220,100, 'Bananas').setScale(1.5)
        this.Kiwi = this.physics.add.sprite(480,240, 'Kiwi').setScale(1.5)
        this.Strawberry = this.physics.add.sprite(130,20, 'Strawberry').setScale(1.5)
        

        //animasi apel
        this.anims.create({
            key: 'Apple',
            frames: this.anims.generateFrameNumbers(
            'Apple', {start: 0, end: 11}),
            frameRate: 3,
            repeat: -1
        })
        //collide apel platform
        this.physics.add.collider(this.apel,this.platforms)

        //animasi bendera
        this.bendera = this.physics.add.sprite(580, 30, 'Checkpoint').setScale(1.2)

        this.anims.create({
            key: 'Checkpoint',
            frames: this.anims.generateFrameNumbers(
            'Checkpoint', {start: 0, end: 9}),
            frameRate: 3,
            repeat: -1
        })
        //collide bendera platform
        this.physics.add.collider(this.bendera,this.platforms)
        
        //animasi api
        this.api = this.physics.add.sprite(160, 500, 'On').setScale(1.2)

        this.anims.create({
            key: 'api',
            frames: this.anims.generateFrameNumbers(
            'On', {start: 0, end: 2}),
            frameRate: 3,
            repeat: -1
        })
        //collide api platform
        this.physics.add.collider(this.api,this.platforms)

        this.api2 = this.physics.add.sprite(190, 250, 'api2').setScale(1.2)

        this.anims.create({
            key: 'api2',
            frames: this.anims.generateFrameNumbers(
            'api2', {start: 0, end: 2}),
            frameRate: 3,
            repeat: -1
        })
        //collide api platform
        this.physics.add.collider(this.api2,this.platforms)

        this.api3 = this.physics.add.sprite(440, 90, 'api3').setScale(1.2)

        this.anims.create({
            key: 'api3',
            frames: this.anims.generateFrameNumbers(
            'api3', {start: 0, end: 2}),
            frameRate: 3,
            repeat: -1
        })
        //collide api platform
        this.physics.add.collider(this.api3,this.platforms)

        //buat saw
        this.saw = this.physics.add.sprite(150, 30, 'saw')
        .setScale(1).setImmovable(true)
        this.saw.body.allowGravity = false;
        this.saw.setBounce(1);
        //animasi saw
        this.anims.create({
            key: 'saw',
            frames: this.anims.generateFrameNumbers(
            'saw', {start: 0, end: 7}),
            frameRate: 10,
            repeat: -1
        })

        //nampilin saw
        this.tweens.add({
            targets: this.saw,
            duration: 2000,
            y: 570, //berapa jauh lebarnya
            loop: -1,
            yoyo: true,
        });

         //buat saw2
         this.saw2 = this.physics.add.sprite(170, 110, 'saw2')
         .setScale(1).setImmovable(true)
         this.saw2.body.allowGravity = false;
         this.saw2.setBounce(1);
         //animasi saw2
         this.anims.create({
             key: 'saw2',
             frames: this.anims.generateFrameNumbers(
             'saw2', {start: 0, end: 7}),
             frameRate: 10,
             repeat: -1
         })
 
         //nampilin saw2
         this.tweens.add({
             targets: this.saw2,
             duration: 2000,
             x: 700, //berapa jauh lebarnya
             loop: -1,
             yoyo: true,
         });

           //buat saw3
           this.saw3 = this.physics.add.sprite(150, 500, 'saw3')
           .setScale(1).setImmovable(true)
           this.saw3.body.allowGravity = false;
           this.saw3.setBounce(1);
           //animasi saw3
           this.anims.create({
               key: 'saw3',
               frames: this.anims.generateFrameNumbers(
               'saw3', {start: 0, end: 7}),
               frameRate: 10,
               repeat: -1
           })
   
           //nampilin saw3
           this.tweens.add({
               targets: this.saw3,
               duration: 2000,
               x: 700, //berapa jauh lebarnya
               loop: -1,
               yoyo: true,
           });
 
       //buat saw4
       this.saw4 = this.physics.add.sprite(500, 30, 'saw4')
       .setScale(1).setImmovable(true)
       this.saw.body.allowGravity = false;
       this.saw.setBounce(1);
       //animasi saw
       this.anims.create({
           key: 'saw4',
           frames: this.anims.generateFrameNumbers(
           'saw4', {start: 0, end: 7}),
           frameRate: 10,
           repeat: -1
       })

       //nampilin saw4
       this.tweens.add({
           targets: this.saw4,
           duration: 2000,
           y: 570, //berapa jauh lebarnya
           loop: -1,
           yoyo: true,
       });

        this.anims.create({
            key: 'Bananas',
            frames: this.anims.generateFrameNumbers(
            'Bananas', {start: 0, end: 11}),
            frameRate: 3,
            repeat: -1
        })

        this.physics.add.collider(this.Bananas,this.platforms)

        this.anims.create({
            key: 'Kiwi',
            frames: this.anims.generateFrameNumbers(
            'Kiwi', {start: 0, end: 11}),
            frameRate: 3,
            repeat: -1
        })

        this.physics.add.collider(this.Kiwi,this.platforms)

        this.anims.create({
            key: 'Strawberry',
            frames: this.anims.generateFrameNumbers(
            'Strawberry', {start: 0, end: 11}),
            frameRate: 3,
            repeat: -1
        })

        this.physics.add.collider(this.Strawberry,this.platforms)

        this.physics.add.overlap(this.player,this.saw,this.gameOver,undefined,this)
        this.physics.add.overlap(this.player,this.saw2,this.gameOver,undefined,this)
        this.physics.add.overlap(this.player,this.saw3,this.gameOver,undefined,this)
        this.physics.add.overlap(this.player,this.saw4,this.gameOver,undefined,this)

        this.physics.add.overlap(this.player,this.api,this.gameOver,undefined,this)
        this.physics.add.overlap(this.player,this.api2,this.gameOver,undefined,this)
        this.physics.add.overlap(this.player,this.api3,this.gameOver,undefined,this)

        this.physics.add.overlap(this.player,this.apel,this.eatApel,undefined,this)
        this.physics.add.overlap(this.player,this.Kiwi,this.eatKiwi,undefined,this)
        this.physics.add.overlap(this.player,this.Strawberry,this.eatStrawberry,undefined,this)
        this.physics.add.overlap(this.player,this.Bananas,this.eatBanana,undefined,this)
        this.physics.add.overlap(this.player,this.bendera,this.eatBendera,undefined,this)

     
        this.ScoreLabel = this.createScoreLable(255, 20, 0)
        
        this.backsound = this.sound.add('backsound', {volume: 0.5})
        var soundConfig = {
            loop : true
        }
        this.backsound.play(soundConfig)


      
    }
    update()
    {
        this.moveplayer(this.player)
        this.apel.anims.play('Apple', true)
        this.bendera.anims.play('Checkpoint', true)
        this.api.anims.play('api', true)
        this.api2.anims.play('api2', true)
        this.api3.anims.play('api3', true)
        this.saw.anims.play('saw', true)
        this.saw2.anims.play('saw2', true)
        this.saw3.anims.play('saw3', true)
        this.saw4.anims.play('saw4', true)
        this.Strawberry.anims.play('Strawberry', true)
        this.Kiwi.anims.play('Kiwi', true)
        this.Bananas.anims.play('Bananas', true)


    }

    createPlayer()
    {
        const player = this.physics.add.sprite(20, 570,'player3')
        player.setCollideWorldBounds(true)
  
        this.anims.create({
            key: 'left',
            frames: this.anims.generateFrameNumbers(
            'player3', {start: 22, end: 32}),
            frameRate: 10,
            repeat: -1
        })
        this.anims.create({
            key: 'right',
            frames: this.anims.generateFrameNumbers('player3',
            {start:11, end:21}),
            frameRate: 10,
            repeat: -1
            })

        this.anims.create({
            key: 'jump',
            frames: this.anims.generateFrameNumbers('player3',
            {start:33, end:38}),
            frameRate: 10,
            repeat: -1
        })
        this.anims.create({
            key: 'stand-by',
            frames: this.anims.generateFrameNumbers('player3',
            {start:0, end:10}),
            frameRate: 3,
            repeat: -1
        })

        this.anims.create({
            key: 'down',
            frames: this.anims.generateFrameNumbers('player3',
            {start:11, end:21}),
            frameRate: 10,
            repeat: -1
            })
        
            return player

    }

    moveplayer(player)
    {
        const speed = 200
        if(this.cursors.left.isDown){
            this.player.setVelocity(-speed,0)
            this.player.anims.play('right',true)
            this.player.flipX=true
        }else if(this.cursors.right.isDown){
            this.player.setVelocity(speed,0)
            this.player.anims.play('right',true)
            this.player.flipX=false
        }else if(this.cursors.up.isDown){
            this.player.setVelocity(0,-speed)
            this.player.anims.play('jump',true)
        }else if(this.cursors.down.isDown){
            this.player.setVelocity(0, speed)
            this.player.anims.play('down',true)
        }else{
            this.player.setVelocity(0,0)
            this.player.anims.play('stand',true)
            }
        }

        createLifeLable(x, y, score)
        {
            const style = { fontSize: '32px', fill: '#000' }
            const label = new LifeLabel(this, x, y,
                score, style).setDepth(1)

                this.add.existing(label)

                return label

        }

        createScoreLable(x, y, score)
        {
            const style = { fontSize: '32px', fill: '#000' }
            const label = new ScoreLabel(this, x, y,
                score, style).setDepth(1)

                this.add.existing(label)

                return label

        }

        gameOver()
        {
            this.scene.start('game-over-scene')
            this.sound.stopAll()

        }

        eatApel(player,apel){
            apel.disableBody(true, true)
            this.ScoreLabel.add(1)
            this.sound.play('eat')
            if (this.ScoreLabel.getScore() == 5){
                this.scene.start('win-scene')
                this.sound.stopAll()

            }
            
        }
        eatKiwi(player,kiwi){
            kiwi.disableBody(true, true)
            this.ScoreLabel.add(1)
            this.sound.play('eat')
            if (this.ScoreLabel.getScore() == 5){
                this.scene.start('win-scene')
                this.sound.stopAll()
            }
            
        }
        eatBanana(player,bananas){
            bananas.disableBody(true, true)
            this.ScoreLabel.add(1)
            this.sound.play('eat')
            if (this.ScoreLabel.getScore() == 5){
                this.scene.start('win-scene')
                this.sound.stopAll()
            }
            
        }
        eatStrawberry(player,strawberry){
            strawberry.disableBody(true, true)
            this.ScoreLabel.add(1)
            this.sound.play('eat')
            if (this.ScoreLabel.getScore() == 5){
                this.scene.start('win-scene')
                this.sound.stopAll()
            }
            
        }
        eatBendera(player,bendera){
            bendera.disableBody(true, true)
            this.ScoreLabel.add(1)
            this.sound.play('eat')
            if (this.ScoreLabel.getScore() == 5){
                this.scene.start('win-scene')
                this.sound.stopAll()
            }
            
        }

}